import { AxiosInstance } from 'axios';
import { AccessTokenContext } from '../types';
import TokenService from './TokenService';

export default function withJWTRefreshment(axios: AxiosInstance, context?: AccessTokenContext) {
  axios.interceptors.response.use(
    (res) => res,
    async (error) => {
      if (error.response?.status === 401) {
        if (!context && error.config.accessTokenContext) {
          context = error.config.accessTokenContext;
        }

        if (!context) {
          context = null;
        }

        const token = (await TokenService.updateToken(context)).token;

        error.config.headers['Authorization'] = `Bearer ${token}`;
      }

      throw error;
    },
  );

  return axios;
}
